import * as t from 'io-ts';
import { DateFromISOString } from 'io-ts-types';
export const CookieConsents = t.intersection([
    t.type({
        functional: t.boolean,
        analytics: t.boolean,
        marketing: t.boolean,
    }),
    t.partial({
        createdAt: DateFromISOString,
    }),
]);
